import { Component, DestroyRef, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { FORM_FIELDS } from 'src/const-data/form-field-mappings';
import { FormFieldDropdowns } from 'src/const-data/form-field-dropdowns';
import { ValidationFeedback } from 'src/const-data/validation-feedback';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css'],
  standalone: false
})
export class PricingComponent implements OnChanges {
  @Output()
  readonly onStepForward: EventEmitter<void> = new EventEmitter();
  @Output()
  readonly onStepBackward: EventEmitter<void> = new EventEmitter();

  @Input()
  pricingForm!: FormGroup;
  @Input()
  projectId!: string;

  protected readonly validationFeedback = ValidationFeedback;
  protected readonly dropdowns = FormFieldDropdowns.dropDowns;
  protected readonly fields = FORM_FIELDS.PRICING;

  private readonly destroyRef = inject(DestroyRef);
  private lastLoadedProjectId: string | null = null;
  private lastLoadedForm: FormGroup | null = null;

  constructor(private readonly dataService: DataService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectId'] || changes['pricingForm']) {
      this.tryLoadProjectData();
    }
  }

  private tryLoadProjectData(): void {
    const id = (this.projectId ?? '').trim();
    const form = this.pricingForm;
    if (!id || !form) return;
    if (this.lastLoadedProjectId === id && this.lastLoadedForm === form) return;

    this.lastLoadedProjectId = id;
    this.lastLoadedForm = form;

    this.dataService
      .readData(form, id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          // Data loaded successfully
        },
        error: () => {
          // Error already handled by DataTransferService with toast notification
        }
      });
  }

  nextStep() {
    this.onStepForward.emit();
  }

  stepBack() {
    this.onStepBackward.emit();
  }
}
